import TenantsApiService from './_services/tenants.api.service';

import { MutationTypes, ActionTypes } from './store.types';

export { namespace } from './store.types';

export default {
  namespaced: true,
  state: {
    tenants: [],
    allTenants: [],
    tenantHistory: [],
  },
  mutations: {
    [MutationTypes.SET_TENANTS](state, payload) {
      state.tenants = payload;
    },
    [MutationTypes.SET_ALL_TENANTS](state, payload) {
      state.allTenants = payload;
    },
    [MutationTypes.SET_TENANT_HISTORY](state, payload) {
      state.tenantHistory = payload;
    },
  },
  actions: {
    async [ActionTypes.GET_TENANTS]({ commit }, { ...rest }) {
      commit(MutationTypes.SET_TENANTS, await TenantsApiService.getTenants({ ...rest }));
    },
    async [ActionTypes.GET_ALL_TENANTS]({ commit }) {
      commit(MutationTypes.SET_ALL_TENANTS, await TenantsApiService.getAllTenants());
    },
    async [ActionTypes.GET_TENANT_HISTORY]({ commit }, { pageNum, ...rest }) {
      commit(
        MutationTypes.SET_TENANT_HISTORY,
        await TenantsApiService.getTenantHistory({ pageNum, ...rest }),
      );
    },
  },
};
